import clsx from 'clsx';

import BaseCollapseWithGradient from '@components/base/BaseCollapseWithGradient';

import { LocaleTypes } from '@i18n';

import styles from './BlockSeo.module.scss';

interface IBlockSeoProps {
    locale: LocaleTypes;
}

const BlockSeo: React.FC<IBlockSeoProps> = ({ locale }) => {
    return (
        <section className={clsx(styles.landingContainer, styles.blockSeo)}>
            <BaseCollapseWithGradient>
                {locale === LocaleTypes.ru && (
                    <div>
                        <h1 className="font-medium text-blueGray-800 text-sub sm:text-h2">
                            CPA: что это такое в маркетинге?
                        </h1>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            CPA: Что это такое?
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Cost Per Action - это модель монетизации и рекламы, главная идея которой
                            платить только за целевые действия пользователя, например как
                            совершенная покупка товара, подписка на рассылку, прохождение и
                            заполнение анкеты. Это и отличает ее от других подобных моделей
                            монетизации, таких как CPM или CPC.
                        </p>
                        <br />
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            CPA сеть - рекламодатель размещает свои рекламные материалы на сайтах
                            партнеров, и за каждую целевую активность, такую как покупка продукта,
                            заполнение анкеты или регистрация на сайте, рекламодатель платит
                            определенное вознаграждение.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            Какие сферы бизнеса могут работать в партнерской сети?
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            CPA сеть широко используются в интернет-маркетинге и охватывают
                            различные сферы бизнеса, включая онлайн-магазины, маркетплейсы, банки и
                            другие. Таким образом, практически любой бизнес может использовать CPA
                            сеть для эффективного привлечения клиентов и увеличения продаж.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            Аффилиатные товары
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Предложения, которые рекламодатель предлагает разместить на площадке
                            вебмастера. Это могут быть как физические товары, так и цифровые или
                            услуги. CPA сеть имеет широкий спектр различных предложений, которые
                            позволяют вебмастерам или блогерам выбирать офферы, наиболее подходящие
                            для их аудитории. Товары представлены в каталогах партнерских программ,
                            где исполнитель может выбрать наиболее выгодный вариант для своей
                            рекламной кампании.
                        </p>
                        <br />
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            CPA сеть ePN предлагает различные типы офферов, включая продажу товаров,
                            подписку на услуги, установку мобильных приложений и многое другое.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            Как выбрать надежного агрегатора партнерских программ?
                        </h3>
                        <p className="font-medium text-blueGray-800 text-p2 sm:text-p1">
                            Основные факторы которые должен учитывать рекламодатель при выборе:
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            1. Репутация и надежность
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Важно выбирать агрегатора с хорошей репутацией и долголетием на рынке.
                            Исследуйте отзывы и рекомендации других рекламодателей, оцените качество
                            обслуживания и профессионализм команды. Выбирайте только белую CPA сеть.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            2. Качество трафика
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Отбирайте CPA сеть, которые обеспечивают высококачественный трафик, а
                            именно потенциальных клиентов, заинтересованных в вашем продукте или
                            услуге. Исследуйте их методы генерации трафика и определите, насколько
                            эти методы соответствуют вашим потребностям.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            3. Разнообразие предложений
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Проверьте, какие предложения предоставляет CPA сеть. Если у вас есть
                            конкретный продукт или услуга, убедитесь, что CPA сеть специализируется
                            в данной нише и имеет соответствующий набор предложений.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            4. Отчетность и аналитика
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Важно иметь доступ к детальной отчетности и аналитике по вашим
                            кампаниям. CPA сеть должна предоставлять информацию о производительности
                            кампании, конверсиях и ROI. Убедитесь, что предоставляемые отчеты
                            понятны и информативны.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            5. Техническая поддержка
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            В случае возникновения проблем или вопросов, агрегатор должен иметь
                            качественную техническую поддержку, это может быть решающим фактором при
                            выборе. Узнайте, как быстро и эффективно CPA сеть отвечает на запросы,
                            предоставляет помощь и решает технические проблемы.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            6. Условия партнерства
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Изучите CPA сеть, а именно условия работы, такие как: выплаты;
                            минимальный порог выплаты; способы оплаты; возможность использования
                            различных видов трафика; правила и ограничения. Убедитесь, что CPA сеть
                            устраивают вас и соответствуют вашим потребностям.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            CPA сеть ePN: как начать?
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Для начала работ необходимо заключить договор на оказание услуг между
                            вебмастером, рекламодателем и агрегатором ePN. Для этого необходимо
                            оставить заявку на сайте, заполнив соответствующую анкету. В самом
                            договоре мы обязательно указываем цену за выполненное действие.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            Какие возможности предоставляет CPA сеть ePN:
                        </h3>
                        <ul className="pl-5 list-disc">
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                высокая конверсия в целевые действия
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                возможность привлечения новых клиентов
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                оплата только за качественный трафик
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                гибкие условия сотрудничества
                            </li>
                        </ul>
                        <br />
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Таким образом, сервис ePN предлагает рекламодателям выгодные условия
                            сотрудничества. Мы помогаем запустить эффективные рекламные кампании и
                            привлечь целевую аудиторию на их ресурс, а вебмастерам получать
                            дополнительный доход от своего сайта.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            CPA сеть: за что платит рекламодатель?
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Существуют множество действий за которые производится оплата, но давайте
                            рассмотрим основные:
                        </p>
                        <br />
                        <ul className="pl-5 list-disc">
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                за привлеченный лид;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                за загруженный файл;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                за просмотр видео;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                за совершенную покупку;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                за изучение прайс-листа;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                произошло заполнение формы заказа;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                за заполнение обратной формы для связи;
                            </li>
                        </ul>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            Вывод{' '}
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            В итоге, выбирая CPA сеть рекламодатель должен учитывать все факты
                            приведенные выше, а именно: репутацию, качество трафика, разнообразие
                            предложений, доступность отчетности, качество технической поддержки и
                            условия партнерства. Правильный выбор поможет вам достичь максимальной
                            эффективности рекламной кампании и получать только качественный трафик.
                            Регистрируйтесь в нашем сервисе ePN и получайте новых клиентов с высокой
                            конверсией.
                        </p>
                    </div>
                )}
                {locale === LocaleTypes.en && (
                    <div>
                        <h1 className="font-medium text-blueGray-800 text-sub sm:text-h2">
                            CPA: what is it in marketing?
                        </h1>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            CPA: what is it?
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Cost Per Action (CPA) is a model of monetization and advertising in
                            which the advertiser pays only for specific user actions, such as making
                            a purchase, subscribing to a newsletter, or completing a survey. This
                            distinguishes it from other similar monetization models, such as CPM or
                            CPC.
                        </p>
                        <br />
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            In a CPA network, advertisers place their ads on partner websites, and
                            for each target action, such as a product purchase, survey completion,
                            or website registration, the advertiser pays a certain reward.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            Which business industries can work in an affiliate network?
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            CPA networks are widely used in internet marketing and encompass various
                            business sectors, including online stores, marketplaces, banks, and
                            others. Therefore, practically any business can use a CPA network to
                            effectively attract customers and increase sales.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            Affiliate Products
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            These are offers that the advertiser proposes to be placed on the
                            webmaster&apos;s platform. These can be physical products, digital
                            goods, or services. A CPA network has a wide range of different offers
                            that allow webmasters or bloggers to choose the offers that are most
                            suitable for their audience. The products are presented in the catalogs
                            of affiliate programs, where the affiliate can choose the most
                            advantageous option for their advertising campaign.
                        </p>
                        <br />
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            The ePN CPA network offers various types of offers, including the sale
                            of products, subscription to services, mobile app installations, and
                            much more.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            How to choose a reliable affiliate program aggregator?
                        </h3>
                        <p className="font-medium text-blueGray-800 text-p2 sm:text-p1">
                            The main factors that advertisers should consider when choosing are:
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            1. Reputation and reliability
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            It is important to choose an aggregator with a good reputation and
                            longevity in the market. Research reviews and recommendations from other
                            advertisers, assess the quality of service and professionalism of the
                            team. Choose only a white CPA network.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            2. Traffic quality
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Choose a CPA network that provides high-quality traffic, namely
                            potential customers interested in your product or service. Investigate
                            their methods of traffic generation and determine how well these methods
                            fit your needs.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            3. Variety of offers
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Check what offers the CPA network provides. If you have a specific
                            product or service, make sure the CPA network specializes in that niche
                            and has a corresponding set of offers.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            4. Reporting and analytics
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            It is important to have access to detailed reporting and analytics on
                            your campaigns. The CPA network should provide information on campaign
                            performance, conversions, and ROI. Make sure the reports provided are
                            clear and informative.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            5. Technical support
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            In case of problems or questions, the aggregator should have quality
                            technical support, which can be a decisive factor in choosing. Find out
                            how quickly and effectively the CPA network responds to inquiries,
                            provides assistance, and solves technical issues.
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            6. Partnership terms
                        </p>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Study the CPA network, specifically the terms of work, such as: payouts;
                            minimum payout threshold; payment methods; the ability to use various
                            types of traffic; rules and restrictions. Make sure that the CPA network
                            suits you and meets your needs.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            CPA network ePN: How to get started?
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            To begin working, it is necessary to sign a service agreement between
                            the webmaster, advertiser, and ePN aggregator. To do this, you need to
                            submit an application on the website, filling out the corresponding
                            form. In the agreement, we always specify the price for the completed
                            action.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            What opportunities does the CPA network ePN provide:
                        </h3>
                        <ul className="pl-5 list-disc">
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                high conversion to target actions
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                the possibility of attracting new clients
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                payment only for quality traffic
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                flexible collaboration terms
                            </li>
                        </ul>
                        <br />
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            Thus, the ePN service offers advertisers profitable collaboration
                            conditions. We help launch effective advertising campaigns and attract a
                            target audience to their resource, while webmasters can earn additional
                            income from their website.
                        </p>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            CPA network: What does the advertiser pay for?
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            There are many actions for which payment is made, but let&apos;s
                            consider the main ones:
                        </p>
                        <br />
                        <ul className="pl-5 list-disc">
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                for attracting leads;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                for downloading files;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                for watching videos;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                for making a purchase;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                for studying a price list;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                for filling out an order form;
                            </li>
                            <li className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                                for filling out a contact form;
                            </li>
                        </ul>
                        <br />
                        <h3 className="font-medium text-blueGray-800 text-p1 sm:text-sub">
                            Conclusion
                        </h3>
                        <p className="font-normal text-blueGray-800 text-p2 sm:text-p1">
                            In the end, when choosing a CPA network, the advertiser should consider
                            all the facts mentioned above, namely: reputation, traffic quality,
                            variety of offers, accessibility of reporting, quality of technical
                            support, and partnership terms. Making the right choice will help you
                            achieve maximum advertising campaign efficiency and receive only quality
                            traffic. Register in our ePN service and attract new clients with high
                            conversion.
                        </p>
                    </div>
                )}
            </BaseCollapseWithGradient>
        </section>
    );
};

export default BlockSeo;
